"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[981],{

/***/ 70255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jr": function() { return /* binding */ useBaseFeePerGasStats; },
  "nv": function() { return /* binding */ useBaseFeePerGasStatsTimeFrame; },
  "BZ": function() { return /* binding */ useBlobBaseFeeStats; }
});

// UNUSED EXPORTS: fetchBaseFeePerGasStats, fetchBaseFeePerGasStatsTimeFrame

// EXTERNAL MODULE: ./node_modules/date-fns/esm/secondsToMilliseconds/index.js
var secondsToMilliseconds = __webpack_require__(62523);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/minutesToMilliseconds/index.js


/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */

function minutesToMilliseconds(minutes) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(minutes * constants/* millisecondsInMinute */.yJ);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/hoursToMilliseconds/index.js


/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted to milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */

function hoursToMilliseconds(hours) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(hours * constants/* millisecondsInHour */.vh);
}
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/base-fee-per-gas-stats.ts




const url = "/api/v2/fees/base-fee-per-gas-stats";
const blob_url = "/api/v2/fees/blob-fee-per-gas-stats";
const fetchBaseFeePerGasStats = ()=>fetchApiJson(url);
const useBlobBaseFeeStats = ()=>{
    const { data  } = (0,dist/* default */.ZP)(blob_url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    });
    return data;
};
const useBaseFeePerGasStats = ()=>{
    const { data  } = (0,dist/* default */.ZP)(url, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: (0,secondsToMilliseconds/* default */.Z)(4)
    });
    return data;
};
const fetchBaseFeePerGasStatsTimeFrame = (timeFrame)=>fetchApiJson("".concat(url, "?time_frame=").concat(timeFrame));
const refreshIntervalMap = {
    m5: (0,secondsToMilliseconds/* default */.Z)(4),
    h1: (0,secondsToMilliseconds/* default */.Z)(4),
    d1: minutesToMilliseconds(1),
    d7: minutesToMilliseconds(10),
    d30: hoursToMilliseconds(1),
    since_burn: hoursToMilliseconds(1),
    since_merge: hoursToMilliseconds(1)
};
const useBaseFeePerGasStatsTimeFrame = function(timeFrame) {
    let blobFees = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const fullUrl = "".concat(blobFees ? blob_url : url, "?time_frame=").concat(timeFrame);
    if (blobFees) {
        console.log("Requesting blob fees over time:", fullUrl);
    }
    const { data  } = (0,dist/* default */.ZP)(fullUrl, fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: refreshIntervalMap[timeFrame]
    });
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return data;
};


/***/ }),

/***/ 57981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81472);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17857);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89802);
/* harmony import */ var _components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90079);
/* harmony import */ var _components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46400);
/* harmony import */ var _components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69443);
/* harmony import */ var _eth_units__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41492);
/* harmony import */ var _format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12597);
/* harmony import */ var _api_base_fee_per_gas_stats__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70255);
/* harmony import */ var _TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62925);











const GWEI_FORMATTING_THRESHOLD = 100000000; // Threshold in wei above which to convert to / format as Gwei
const getPercentage = (highest, lowest, gas)=>{
    const range = highest - lowest;
    return (gas - lowest) / range;
};
const getBlockPageLink = (u)=>typeof u === "undefined" ? undefined : "https://etherscan.io/block/".concat(u);
const Marker = (param)=>{
    let { blockNumber , emphasize =false , gas , highest , horizontal , label , lowest , markerColor , vertical , convertToGwei  } = param;
    // TODO: rewrite to use translation
    const styles = (0,_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.useSpring)({
        left: "".concat(getPercentage(highest, lowest, gas) * 100, "%")
    });
    const gasFormatted = convertToGwei ? gas / _eth_units__WEBPACK_IMPORTED_MODULE_7__/* .WEI_PER_GWEI */ .c1 : gas;
    const unit = convertToGwei ? "Gwei" : "wei";
    const decimals = convertToGwei ? 2 : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_react_spring_web__WEBPACK_IMPORTED_MODULE_1__.animated.div, {
        className: "\n        absolute flex\n        -translate-x-1/2 flex-col items-center\n        ".concat(vertical === "top" ? "-top-[48px]" : "-bottom-[40px]", "\n      "),
        style: styles,
        title: "ultra sound barrier",
        children: [
            vertical === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "\n            h-12 w-px\n            rounded-b-full\n            ".concat(markerColor, "\n          ")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: emphasize ? undefined : "text-slateus-400",
                className: "\n            absolute top-2\n            ".concat(vertical === "top" ? "top-2" : "top-3", "\n            ").concat(horizontal === "right" ? "left-2" : "right-2", "\n            ").concat(emphasize ? "" : "text-slateus-400", "\n          "),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_QuantifyText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "\n          absolute\n          ".concat(vertical === "top" ? "top-6" : "top-7", "\n          ").concat(horizontal === "right" ? "left-2" : "right-2", "\n        "),
                color: label === "average" ? "bg-gradient-to-r bg-clip-text text-transparent from-orange-400 to-yellow-300" : emphasize ? "text-white" : "text-slateus-200",
                size: "text-sm",
                unitPostfix: vertical === "top" ? unit : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: getBlockPageLink(blockNumber),
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        end: gasFormatted,
                        preserveValue: true,
                        formattingFn: _format__WEBPACK_IMPORTED_MODULE_8__/* .formatOneDecimal */ .F9,
                        duration: 1,
                        useEasing: true,
                        decimals: decimals
                    })
                })
            }),
            vertical === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-2 h-12 w-px rounded-t-full ".concat(markerColor)
            })
        ]
    });
};
const GasMarketWidget = (param)=>{
    let { onClickTimeFrame , timeFrame  } = param;
    var ref;
    const blobBaseFeeStats = (0,_api_base_fee_per_gas_stats__WEBPACK_IMPORTED_MODULE_9__/* .useBlobBaseFeeStats */ .BZ)();
    const blobBaseFeeStatsTimeFrame = blobBaseFeeStats === null || blobBaseFeeStats === void 0 ? void 0 : (ref = blobBaseFeeStats.blob_base_fee_stats) === null || ref === void 0 ? void 0 : ref[timeFrame];
    const barPaddingFactor = 0.08;
    const lowest = blobBaseFeeStatsTimeFrame === undefined ? undefined : blobBaseFeeStatsTimeFrame.min - blobBaseFeeStatsTimeFrame.max * barPaddingFactor;
    const highest = blobBaseFeeStatsTimeFrame === undefined ? undefined : blobBaseFeeStatsTimeFrame.max * (1 + barPaddingFactor);
    const gasRange = highest === undefined || lowest === undefined ? undefined : highest - lowest;
    const averagePercent = blobBaseFeeStatsTimeFrame === undefined || gasRange === undefined || lowest === undefined ? undefined : (blobBaseFeeStatsTimeFrame.average - lowest) / gasRange * 100;
    const isDataAvailable = blobBaseFeeStatsTimeFrame !== undefined && highest !== undefined && lowest !== undefined && averagePercent !== undefined;
    const deltaLeft = "".concat(averagePercent, "%");
    const deltaWidth = averagePercent === undefined ? undefined : "".concat(Math.abs(averagePercent), "%");
    const convertToGwei = blobBaseFeeStatsTimeFrame !== undefined && blobBaseFeeStatsTimeFrame.max > GWEI_FORMATTING_THRESHOLD;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        title: "blob gas market",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__/* .WidgetBackground */ .K, {
            className: "flex flex-col gap-y-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: "blob gas market"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: onClickTimeFrame
                        })
                    ]
                }),
                !isDataAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-[96px] items-center justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: "text-slateus-300",
                        children: "data not yet available"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "\n              relative\n              my-11\n              mx-11\n              flex\n              h-2\n              rounded-full\n              bg-slateus-600\n            ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Marker, {
                                blockNumber: blobBaseFeeStatsTimeFrame.min_block_number,
                                description: "minimum gas price",
                                gas: blobBaseFeeStatsTimeFrame.min,
                                highest: highest,
                                horizontal: "left",
                                label: "min",
                                lowest: lowest,
                                markerColor: "bg-slateus-400",
                                vertical: "bottom",
                                convertToGwei: convertToGwei
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Marker, {
                                blockNumber: blobBaseFeeStatsTimeFrame.max_block_number,
                                description: "maximum gas price",
                                gas: blobBaseFeeStatsTimeFrame.max,
                                highest: highest,
                                horizontal: "right",
                                label: "max",
                                lowest: lowest,
                                markerColor: "bg-slateus-400",
                                vertical: "bottom",
                                convertToGwei: convertToGwei
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Marker, {
                                description: "average gas price",
                                emphasize: true,
                                gas: blobBaseFeeStatsTimeFrame.average,
                                highest: highest,
                                horizontal: "right",
                                label: "average",
                                lowest: lowest,
                                markerColor: averagePercent >= 0 ? "bg-orange-400" : "bg-blue-400",
                                vertical: "top",
                                convertToGwei: convertToGwei
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (GasMarketWidget);


/***/ })

}]);